/*! cpf v2.0.1 | (c) 2015-2019 by Matheus Alves */
!function (r, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.CPF = t() : r.CPF = t();
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    var n = {};
    function o(r) {
      if (n[r]) return n[r].exports;
      var t = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
    }
    return o.m = e, o.c = n, o.d = function (r, t, e) {
      o.o(r, t) || Object.defineProperty(r, t, {
        enumerable: !0,
        get: e
      });
    }, o.r = function (r) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(r, "__esModule", {
        value: !0
      });
    }, o.t = function (t, r) {
      if (1 & r && (t = o(t)), 8 & r) return t;
      if (4 & r && "object" == typeof t && t && t.__esModule) return t;
      var e = Object.create(null);
      if (o.r(e), Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      }), 2 & r && "string" != typeof t) for (var n in t) o.d(e, n, function (r) {
        return t[r];
      }.bind(null, n));
      return e;
    }, o.n = function (r) {
      var t = r && r.__esModule ? function () {
        return r.default;
      } : function () {
        return r;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (r, t) {
      return Object.prototype.hasOwnProperty.call(r, t);
    }, o.p = "", o(o.s = 2);
  }([function (r, t, e) {
    "use strict";

    r.exports = function (r) {
      if ("string" != typeof r) throw new Error("Invalid CPF number");
      var t = r.replace(/\D/g, "");
      if (11 !== t.length) throw new Error("Invalid CPF number");
      return t.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
    };
  }, function (r, t, e) {
    "use strict";

    var o = e(5),
      u = function (r) {
        return /^\d$/.test(r);
      },
      n = function (r, t) {
        return r + t;
      },
      i = function (r) {
        return r.map(function (r, t) {
          return r * (9 - t % 10);
        }).reduce(n);
      };
    r.exports = function () {
      var r = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [],
        t = Array.from(r || []);
      if (!t.every(u) || 9 !== r.length) throw new Error("Invalid digits");
      var e = o(t),
        n = [];
      return n[0] = i(e) % 11 % 10, n[1] = (i([0].concat(function (r) {
        if (Array.isArray(r)) {
          for (var t = 0, e = Array(r.length); t < r.length; t++) e[t] = r[t];
          return e;
        }
        return Array.from(r);
      }(e))) + 9 * n[0]) % 11 % 10, n;
    };
  }, function (r, t, e) {
    "use strict";

    r.exports.format = e(0), r.exports.generate = e(3), r.exports.isValid = e(6);
  }, function (r, t, e) {
    "use strict";

    function u(r) {
      if (Array.isArray(r)) {
        for (var t = 0, e = Array(r.length); t < r.length; t++) e[t] = r[t];
        return e;
      }
      return Array.from(r);
    }
    var i = e(4),
      f = e(1),
      a = e(0);
    r.exports = function () {
      var r = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0],
        t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
        e = i(0, 9).oned(9, {
          round: !0
        }),
        n = t ? i(0, 9).oned(2, {
          round: !0
        }) : f(e),
        o = [].concat(u(e), u(n)).join("");
      return r ? a(o) : o;
    };
  }, function (r, t, e) {
    "use strict";

    var n = function (r, t, e, n) {
      var o = (n || {}).round;
      return Array.apply(null, {
        length: r
      }).map(function () {
        var r = Math.random() * (e - t) + t;
        return !0 === o ? Math.round(r) : r;
      });
    };
    r.exports = function (i, f) {
      return {
        oned: function (r, t) {
          return n(r, i, f, t);
        },
        twod: function (r, t, e) {
          return Array.apply(null, {
            length: r
          }).map(function () {
            return n(t, i, f, e);
          });
        },
        genWhile: function (r, t) {
          for (var e = [], n = (t || {}).limit || 1e4, o = 0; o !== n;) {
            var u = Math.random() * (f - i) + i;
            if (e.push(u), r(u)) return e;
            o += 1;
          }
          return e;
        }
      };
    };
  }, function (r, t, e) {
    "use strict";

    r.exports = function (r) {
      if (!Array.isArray(r)) throw new TypeError("Expected an array");
      return r.reverse();
    };
  }, function (r, t, e) {
    "use strict";

    var a = function (r, t) {
        if (Array.isArray(r)) return r;
        if (Symbol.iterator in Object(r)) return function (r, t) {
          var e = [],
            n = !0,
            o = !1,
            u = void 0;
          try {
            for (var i, f = r[Symbol.iterator](); !(n = (i = f.next()).done) && (e.push(i.value), !t || e.length !== t); n = !0);
          } catch (r) {
            o = !0, u = r;
          } finally {
            try {
              !n && f.return && f.return();
            } finally {
              if (o) throw u;
            }
          }
          return e;
        }(r, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
      c = e(1);
    r.exports = function (r) {
      var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
      if ("string" != typeof r) return !1;
      var e,
        n,
        o = r.replace(/\D/g, "");
      if (!o) return !1;
      if (n = (e = o).charAt(0), RegExp("^" + n + "+$").test(e)) return !1;
      if (11 !== o.length) return !1;
      if (t && 11 === o.length) return !0;
      var u = o.match(/^(\d{9})(\d{2})$/),
        i = a(u, 3),
        f = i[1];
      return i[2] === c(f).join("");
    };
  }]);
});